"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openMenu = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _userEvent = _interopRequireDefault(require("@testing-library/user-event"));
var _reactSelectEvent = _interopRequireDefault(require("react-select-event"));
var openSearchSelectMenu = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(input) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _userEvent.default.click(input);
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function openSearchSelectMenu(_x) {
    return _ref.apply(this, arguments);
  };
}();
var openHandlers = {
  simple: _reactSelectEvent.default.openMenu,
  prefixed: _reactSelectEvent.default.openMenu,
  filter: _reactSelectEvent.default.openMenu,
  search: openSearchSelectMenu
};
var openMenu = function openMenu(input) {
  var selectType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'simple';
  return openHandlers[selectType](input);
};
exports.openMenu = openMenu;